<!--
 * @Author: LiuXin
 * @Date: 2021-12-02 19:06:48
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-12-15 15:30:28
-->
<template>
  <a-space :size="12">
    <a-select style="width: 150px" :value="rule.field ? { value: rule.field, label: rule.fieldName } : null" :options="indicatorOptions" :placeholder="fieldPlaceholder" label-in-value @change="fieldChange"></a-select>
    <a-select style="width: 150px" v-model:value="rule.referenceValue" :options="conditionOptions" placeholder="选择操作" @change="conditionChange" v-if="showBox('referenceValue')"></a-select>
    <a-input style="width: 150px" v-model:value.number="rule.value" placeholder="请输入数值" :suffix="getSuffix" v-if="showBox('value')"></a-input>
    <span v-if="showBox('limitText')">{{ limitTypeDict[rule.limitType] }} </span>
    <!-- 最高限制,最低限制,限制范围 -->
    <a-input style="width: 150px" v-model:value.number="rule.limitValue[0]" placeholder="请输入数值" suffix="元" v-if="showBox('limitValue1')"></a-input>
    <span v-if="showBox('limitValue2')"> - </span>
    <!-- 限制范围 -->
    <a-input style="width: 150px" v-model:value.number="rule.limitValue[1]" placeholder="请输入数值" suffix="元" v-if="showBox('limitValue2')"></a-input>
  </a-space>
</template>

<script>
export default {
  name: 'RuleExecItem',
  components: {},
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const rule = this.$attrs.rule || {};
    return {
      rule,
      limitTypeDict: { 1: '不限制', 2: '最高限制', 3: '最低限制', 4: '限制范围' },
    };
  },
  computed: {
    // 指标下拉配置
    indicatorOptions() {
      return this.options.map(item => {
        return {
          value: item.field,
          label: item.fieldName,
          ...item,
        };
      });
    },
    //执行操作下拉配置
    conditionOptions() {
      const conditionList =
        this.indicatorOptions.find(item => {
          return item.value == this.rule.field;
        })?.condition || [];

      return conditionList.map(item => {
        return {
          label: item.name,
          ...item,
        };
      });
    },
    // 指标placeholder
    fieldPlaceholder() {
      return `请选择第${this.index + 1}步操作`;
    },
  },
  methods: {
    // 指标改变
    fieldChange(val) {
      if (val) {
        this.rule.field = val.value;
        this.rule.fieldName = val.label;
        this.rule.referenceValue = undefined;
        this.rule.valueType = undefined;
        this.conditionChange();
      }
    },
    // 执行操作改变
    conditionChange() {
      this.rule.value = '';
      this.rule.limitValue = [];
    },
    // 生成输入框后缀，设置valueType ,limitType
    getSuffix() {
      const valueTypeDict = { RMB: '元', '%': '%' };
      let condition = this.conditionOptions.find(item => {
        return item.value == this.rule.referenceValue;
      });
      if (condition) {
        this.rule.limitType = condition.limitType;
        this.rule.valueType = condition.valueType;
      }
      return valueTypeDict[condition?.valueType];
    },
    // 控制输入框选择框显隐
    showBox(type) {
      let flag;
      // 开启 暂停 仅通知等操作
      if (this.rule.fieldName && this.conditionOptions[0]?.label == this.rule.fieldName) {
        this.rule.referenceValue = this.conditionOptions[0]?.value;
        return false;
      }
      switch (type) {
        case 'referenceValue':
          flag = this.conditionOptions.length;
          break;
        case 'value':
          flag = this.rule.referenceValue && this.rule.referenceValue < 7;
          break;
        case 'limitValue1':
          flag = this.rule.limitType && this.rule.limitType != 1;
          break;
        case 'limitText':
          flag = this.rule.limitType && this.rule.limitType != 1;
          break;
        case 'limitValue2':
          flag = this.rule.limitType == 4;
          break;
      }
      return flag;
    },
  },
};
</script>

<style scoped lang="less">
</style>
